import React, { createContext, useContext, useState, useEffect } from 'react';

// Traductions FR/EN
const translations = {
  fr: {
    // Navigation & Common
    home: 'Accueil',
    events: 'Événements',
    media: 'Médias',
    news: 'Actualités',
    about: 'À propos',
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'Inscription',
    settings: 'Paramètres',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    add: 'Ajouter',
    close: 'Fermer',
    confirm: 'Confirmer',
    search: 'Rechercher',
    loading: 'Chargement...',
    submit: 'Soumettre',
    send: 'Envoyer',
    sending: 'Envoi...',
    myAccount: 'Mon Compte',
    
    // Auth
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: "Pas encore de compte ?",
    hasAccount: 'Déjà un compte ?',
    signUp: "S'inscrire",
    signIn: 'Se connecter',
    optional: 'optionnel',
    
    // Landing
    heroTitle: 'La billetterie des artistes sénégalais',
    heroSubtitle: 'Créez, gérez et vendez vos billets en toute simplicité',
    getStarted: 'Commencer',
    becomeArtist: 'Devenir artiste',
    discoverArtists: 'Découvrir les artistes',
    featuredArtists: 'Artistes à la une',
    upcomingEvents: 'Événements à venir',
    viewAll: 'Voir tout',
    connectWithFans: 'Connectez avec vos',
    worldwide: 'partout dans le monde',
    whySenArtiste: 'Pourquoi Sen Artiste',
    everythingYouNeed: 'Tout ce dont vous avez besoin',
    ourArtists: 'Nos Artistes',
    discoverTalents: 'Découvrez les talents',
    talentedArtist: 'Artiste talentueux',
    
    // Events
    event: 'Événement',
    eventDetails: "Détails de l'événement",
    dateAndTime: 'Date et heure',
    location: 'Lieu',
    ticketPrice: 'Prix du billet',
    description: 'Description',
    buyTickets: 'Acheter des billets',
    quantity: 'Quantité',
    buyNow: 'Acheter maintenant',
    soldOut: 'Complet',
    availableTickets: 'Places disponibles',
    maxCapacity: 'Capacité maximale',
    
    // Checkout
    checkout: 'Paiement',
    finalizeOrder: "Finaliser l'achat",
    fullName: 'Nom complet',
    totalToPay: 'Total à payer',
    paymentMethod: 'Mode de paiement',
    securePayment: 'Paiement sécurisé',
    pay: 'Payer',
    processing: 'Traitement...',
    paymentSuccess: 'Paiement réussi !',
    paymentPending: 'Paiement en attente',
    paymentFailed: 'Paiement échoué',
    paymentError: 'Erreur de vérification',
    thankYouPurchase: 'Merci pour votre achat. Vos billets sont prêts.',
    ticketsReady: 'Vos billets sont disponibles ci-dessous.',
    paymentProcessing: 'Votre paiement est en cours de traitement.',
    
    // Tickets
    tickets: 'Billets',
    yourTickets: 'Vos billets',
    downloadPDF: 'Télécharger PDF',
    scanQRCode: 'Scannez le QR code à l\'entrée',
    ticketValid: 'Billet valide',
    ticketUsed: 'Billet déjà utilisé',
    ticketInvalid: 'Billet invalide',
    
    // Artist Dashboard
    dashboard: 'Tableau de bord',
    management: 'Gestion',
    myEvents: 'Mes événements',
    myMedia: 'Mes médias',
    myPosts: 'Mes actualités',
    statistics: 'Statistiques',
    revenue: 'Revenus',
    totalSales: 'Ventes totales',
    ticketsSold: 'Billets vendus',
    viewFanpage: 'Voir la fanpage',
    createEvent: 'Créer un événement',
    editEvent: 'Modifier l\'événement',
    eventTitle: 'Titre de l\'événement',
    eventDate: 'Date de l\'événement',
    eventLocation: 'Lieu de l\'événement',
    currency: 'Devise',
    
    // Fanpage
    biography: 'Biographie',
    sendMessage: 'Envoyer un message',
    follow: 'Suivre',
    followers: 'Abonnés',
    pastEvents: 'Événements passés',
    upcoming: 'Prochains',
    gallery: 'Galerie',
    latestNews: 'Dernières nouvelles',
    ended: 'Terminé',
    onSenArtiste: 'sur Sen Artiste',
    writeMessage: 'Écrivez votre message',
    yourMessage: 'Votre message',
    buyATicket: 'Acheter un billet',
    artist: 'Artiste',
    sponsored: 'Sponsorisé',
    visitSite: 'Visiter le site',
    
    // Admin
    adminDashboard: 'Administration',
    artists: 'Artistes',
    users: 'Utilisateurs',
    payments: 'Paiements',
    configuration: 'Configuration',
    notifications: 'Notifications',
    transfers: 'Reversements',
    
    // Messages
    errorOccurred: 'Une erreur est survenue',
    successSaved: 'Enregistré avec succès',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ?',
    noResults: 'Aucun résultat',
    required: 'Requis',
    invalidEmail: 'Email invalide',
    passwordTooShort: 'Mot de passe trop court',
    
    // Confirm dialogs
    deleteConfirmTitle: 'Confirmer la suppression',
    deleteEvent: 'Supprimer cet événement ?',
    deleteEventDesc: 'Cette action est irréversible. L\'événement et tous les billets associés seront définitivement supprimés.',
    deletePost: 'Supprimer cette actualité ?',
    deletePostDesc: 'Cette actualité sera définitivement supprimée.',
    deleteBanner: 'Supprimer cette bannière ?',
    deleteBannerDesc: 'Cette bannière sera définitivement supprimée.',
    deleteMedia: 'Supprimer ce média ?',
    deleteMediaDesc: 'Ce média sera définitivement supprimé de votre galerie.',
    deleteManager: 'Supprimer ce manager ?',
    deleteManagerDesc: 'Ce manager perdra tous ses accès à votre espace artiste.',
    deleteNotification: 'Supprimer cette notification ?',
    deleteNotificationDesc: 'Cette notification sera définitivement supprimée.',
    deleteApporteur: 'Supprimer cet apporteur ?',
    deleteApporteurDesc: 'Cet apporteur et toutes ses données seront définitivement supprimés.',
    executeTransfers: 'Exécuter les transferts ?',
    executeTransfersDesc: 'Voulez-vous exécuter {count} transfert(s) pour un total de {total} ?',
    stripeWarningTitle: 'Compte Stripe non configuré',
    stripeWarningDesc: 'Votre compte Stripe n\'est pas configuré. Les paiements pour cet événement iront sur le compte principal de la plateforme, et vous devrez demander un virement manuel. Pour recevoir les paiements directement, configurez d\'abord votre compte Stripe dans la section "Paiements". Voulez-vous continuer quand même ?',
    continueAnyway: 'Continuer quand même',
    
    // Footer
    allRightsReserved: 'Tous droits réservés',
    termsOfService: 'Conditions d\'utilisation',
    privacyPolicy: 'Politique de confidentialité',
    contact: 'Contact',
    
    // Language
    language: 'Langue',
    french: 'Français',
    english: 'English',
  },
  
  en: {
    // Navigation & Common
    home: 'Home',
    events: 'Events',
    media: 'Media',
    news: 'News',
    about: 'About',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    settings: 'Settings',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    close: 'Close',
    confirm: 'Confirm',
    search: 'Search',
    loading: 'Loading...',
    submit: 'Submit',
    send: 'Send',
    sending: 'Sending...',
    myAccount: 'My Account',
    
    // Auth
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUp: 'Sign up',
    signIn: 'Sign in',
    optional: 'optional',
    
    // Landing
    heroTitle: 'Ticketing for Senegalese artists',
    heroSubtitle: 'Create, manage and sell your tickets with ease',
    getStarted: 'Get Started',
    becomeArtist: 'Become an artist',
    discoverArtists: 'Discover artists',
    featuredArtists: 'Featured Artists',
    upcomingEvents: 'Upcoming Events',
    viewAll: 'View all',
    connectWithFans: 'Connect with your',
    worldwide: 'worldwide',
    whySenArtiste: 'Why Sen Artiste',
    everythingYouNeed: 'Everything you need',
    ourArtists: 'Our Artists',
    discoverTalents: 'Discover the talents',
    talentedArtist: 'Talented artist',
    
    // Events
    event: 'Event',
    eventDetails: 'Event details',
    dateAndTime: 'Date and time',
    location: 'Location',
    ticketPrice: 'Ticket price',
    description: 'Description',
    buyTickets: 'Buy tickets',
    quantity: 'Quantity',
    buyNow: 'Buy now',
    soldOut: 'Sold out',
    availableTickets: 'Available tickets',
    maxCapacity: 'Maximum capacity',
    
    // Checkout
    checkout: 'Checkout',
    finalizeOrder: 'Finalize order',
    fullName: 'Full name',
    totalToPay: 'Total to pay',
    paymentMethod: 'Payment method',
    securePayment: 'Secure payment',
    pay: 'Pay',
    processing: 'Processing...',
    paymentSuccess: 'Payment successful!',
    paymentPending: 'Payment pending',
    paymentFailed: 'Payment failed',
    paymentError: 'Verification error',
    thankYouPurchase: 'Thank you for your purchase. Your tickets are ready.',
    ticketsReady: 'Your tickets are available below.',
    paymentProcessing: 'Your payment is being processed.',
    
    // Tickets
    tickets: 'Tickets',
    yourTickets: 'Your tickets',
    downloadPDF: 'Download PDF',
    scanQRCode: 'Scan QR code at entrance',
    ticketValid: 'Valid ticket',
    ticketUsed: 'Ticket already used',
    ticketInvalid: 'Invalid ticket',
    
    // Artist Dashboard
    dashboard: 'Dashboard',
    management: 'Management',
    myEvents: 'My events',
    myMedia: 'My media',
    myPosts: 'My posts',
    statistics: 'Statistics',
    revenue: 'Revenue',
    totalSales: 'Total sales',
    ticketsSold: 'Tickets sold',
    viewFanpage: 'View fanpage',
    createEvent: 'Create event',
    editEvent: 'Edit event',
    eventTitle: 'Event title',
    eventDate: 'Event date',
    eventLocation: 'Event location',
    currency: 'Currency',
    
    // Fanpage
    biography: 'Biography',
    sendMessage: 'Send message',
    follow: 'Follow',
    followers: 'Followers',
    pastEvents: 'Past events',
    upcoming: 'Upcoming',
    gallery: 'Gallery',
    latestNews: 'Latest News',
    ended: 'Ended',
    onSenArtiste: 'on Sen Artiste',
    writeMessage: 'Write your message',
    yourMessage: 'Your message',
    buyATicket: 'Buy a ticket',
    artist: 'Artist',
    sponsored: 'Sponsored',
    visitSite: 'Visit site',
    
    // Admin
    adminDashboard: 'Administration',
    artists: 'Artists',
    users: 'Users',
    payments: 'Payments',
    configuration: 'Configuration',
    notifications: 'Notifications',
    transfers: 'Transfers',
    
    // Messages
    errorOccurred: 'An error occurred',
    successSaved: 'Successfully saved',
    confirmDelete: 'Are you sure you want to delete?',
    noResults: 'No results',
    required: 'Required',
    invalidEmail: 'Invalid email',
    passwordTooShort: 'Password too short',
    
    // Confirm dialogs
    deleteConfirmTitle: 'Confirm deletion',
    deleteEvent: 'Delete this event?',
    deleteEventDesc: 'This action cannot be undone. The event and all associated tickets will be permanently deleted.',
    deletePost: 'Delete this post?',
    deletePostDesc: 'This post will be permanently deleted.',
    deleteBanner: 'Delete this banner?',
    deleteBannerDesc: 'This banner will be permanently deleted.',
    deleteMedia: 'Delete this media?',
    deleteMediaDesc: 'This media will be permanently removed from your gallery.',
    deleteManager: 'Delete this manager?',
    deleteManagerDesc: 'This manager will lose all access to your artist space.',
    deleteNotification: 'Delete this notification?',
    deleteNotificationDesc: 'This notification will be permanently deleted.',
    deleteApporteur: 'Delete this referrer?',
    deleteApporteurDesc: 'This referrer and all their data will be permanently deleted.',
    executeTransfers: 'Execute transfers?',
    executeTransfersDesc: 'Do you want to execute {count} transfer(s) for a total of {total}?',
    stripeWarningTitle: 'Stripe account not configured',
    stripeWarningDesc: 'Your Stripe account is not configured. Payments for this event will go to the main platform account, and you will need to request a manual transfer. To receive payments directly, first configure your Stripe account in the "Payments" section. Do you want to continue anyway?',
    continueAnyway: 'Continue anyway',
    
    // Footer
    allRightsReserved: 'All rights reserved',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    contact: 'Contact',
    
    // Language
    language: 'Language',
    french: 'Français',
    english: 'English',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('sen-artiste-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('sen-artiste-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
